import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useDarkMode } from './lib/darkMode.tsx';

const Navbar = lazy(() => import('./components/Navbar'));
const Footer = lazy(() => import('./components/Footer'));
const Home = lazy(() => import('./pages/Home'));
const MovieDetails = lazy(() => import('./pages/MovieDetails'));
const Profile = lazy(() => import('./pages/Profile'));
const Auth = lazy(() => import('./pages/Auth'));
const PopularFilms = lazy(() => import('./pages/PopularFilms'));
const AllReviews = lazy(() => import('./pages/AllReviews'));
const FilmSubmissionForm = lazy(() => import('./components/FilmSubmissionForm'));
const Pornsonalities = lazy(() => import('./pages/Pornsonalities'));
const FilmTinder = lazy(() => import('./pages/FilmTinder'));
const TagPage = lazy(() => import('./pages/TagPage'));
const AllTags = lazy(() => import('./pages/AllTags'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Announcement = lazy(() => import('./pages/Announcement'));

function App() {
  const { isDarkMode } = useDarkMode();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200 flex flex-col">
      <Navbar />
      <main className="flex-1 md:container mx-auto md:px-4 md:py-4">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/movie/:id" element={<MovieDetails />} />
          <Route path="/popular" element={<PopularFilms />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/reviews" element={<AllReviews />} />
          <Route path="/submit-film" element={<FilmSubmissionForm />} />
          <Route path="/tinder" element={<FilmTinder />} />
          <Route path="/pornsonalities" element={<Pornsonalities />}>
            <Route path=":type" element={<Pornsonalities />} />
            <Route path="result/:id" element={<Pornsonalities />} />
          </Route>
          <Route path="/tinder/:sessionId" element={<FilmTinder />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/announcement" element={<Announcement />} />
          <Route path="/tag/:tag" element={<TagPage />} />
          <Route path="/tags" element={<AllTags />} />
        </Routes>
      </Suspense>
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App